import React from 'react'
import TabLinkUI from "../../../../widgets/output/TabLinkUI"

const MasterTemplateNavUI = ({ context, activeTab }) =>
  <div className='g_flex_h g_flex_wrap g_flex_left'>
    <TabLinkUI label='Term Sheet' to='/su/master/termSheet/general' active={activeTab === 'termSheet'} />
    <TabLinkUI label='Loan Agreement' to='/su/master/loanAgreement/general' active={activeTab === 'loanAgreement'} />
    <TabLinkUI label='Escrow Agreement' to='/su/master/escrowAgreement' active={activeTab === 'escrowAgreement'} />
    <TabLinkUI label='Pledge Agreement' to='/su/master/pledgeAgreement' active={activeTab === 'pledgeAgreement'} />
    <TabLinkUI label='Pledge Cum Guarantee' to='/su/master/pledgeCumGuarantee' active={activeTab === 'pledgeCumGuarantee'} />
    <TabLinkUI label='NDU' to='/su/master/ndu' active={activeTab === 'ndu'} />
    <TabLinkUI label='Personal Guarantee' to='/su/master/personalGuarantee' active={activeTab === 'personalGuarantee'} />
  </div>

export default MasterTemplateNavUI
